import { z } from 'zod';

export const NetworkPermissionGroupItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  scopeType: z.literal('ORGANIZATION_GROUP'),
});

export type NetworkPermissionGroupItem = z.infer<typeof NetworkPermissionGroupItemSchema>;

export const ListNetworkPermissionGroupsResponseSchema = z.object({
  networkId: z.uuid(),
  items: z.array(NetworkPermissionGroupItemSchema),
});

export type ListNetworkPermissionGroupsResponse = z.infer<
  typeof ListNetworkPermissionGroupsResponseSchema
>;
